import React, { useState, useEffect } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  TextField,
  Button,
  Rating,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import BootstrapDialog from "@mui/material/Dialog"; 
import Image from "../../Utils/getImage";

const ApproveManequinDialog = ({
  openDialog,
  handleClose,
  handleApprove,
  data
}) => {
    const handleSubmit = () => {
      
      handleApprove();
      handleClose();
    };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      className="admin-admins"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Mannequin Approval
        <Typography variant="body2" sx={{ mt: 1 }}>
          Mannequin Preview
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <section>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="admin-textfiled">
                <Image src={data} alt='mannequin' width={540} height={250} />
              </div>
            </Grid>
          </Grid>
        </section>
      </DialogContent>

      <DialogActions>
        <>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="add-btn" onClick={handleSubmit}>Approve</Button>
        </>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ApproveManequinDialog;
